import React from 'react';
import { MessageCircle, Calendar, Phone, MapPin } from 'lucide-react';

const PhoneCallLink = ({ phoneNumber, className = "" }) => {
  const handlePhoneClick = () => {
    window.location.href = `tel:${phoneNumber}`;
  };

  return (
    <button 
      onClick={handlePhoneClick}
      className={`flex items-center space-x-3 hover:text-blue-200 transition-colors duration-200 ${className}`}
    >
      <Phone className="h-5 w-5" />
      <span>{phoneNumber}</span>
    </button>
  );
};

const BookingSection = ({ currentContent, openWhatsApp, openBooking }) => {
  return (
    <section id="booking" className="py-20 bg-tilcara-orange text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-5xl font-bold mb-4 font-dancing">
          {currentContent.booking.title}
        </h2>
        <p className="text-xl mb-4 opacity-90">
          {currentContent.booking.subtitle}
        </p>
        <p className="text-lg mb-12 opacity-85 max-w-2xl mx-auto leading-relaxed">
          {currentContent.booking.humanSubtitle}
        </p>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <button
            onClick={openWhatsApp}
            className="bg-green-500 hover:bg-green-600 text-white p-6 rounded-xl transition-all duration-300 transform hover:scale-105 flex items-center justify-center space-x-3"
          >
            <MessageCircle className="h-8 w-8" />
            <div className="text-left">
              <div className="text-xl font-semibold">{currentContent.booking.whatsapp}</div>
              <div className="text-sm opacity-90">Respuesta inmediata</div>
            </div>
          </button>

          <button
            onClick={openBooking}
            className="bg-blue-600 hover:bg-blue-700 text-white p-6 rounded-xl transition-all duration-300 transform hover:scale-105 flex items-center justify-center space-x-3"
          >
            <Calendar className="h-8 w-8" />
            <div className="text-left">
              <div className="text-xl font-semibold">{currentContent.booking.booking}</div>
              <div className="text-sm opacity-90">Reserva online</div>
            </div>
          </button>
        </div>

        <div className="bg-white/10 backdrop-blur-md rounded-xl p-6">
          <div className="grid md:grid-cols-2 gap-6 text-left">
            <PhoneCallLink phoneNumber={currentContent.booking.contact.phone} />
            <div className="flex items-center space-x-3">
              <MapPin className="h-5 w-5" />
              <span>{currentContent.booking.contact.address}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookingSection;
